import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import { NotesProvider } from '@models/notes-provider.interface';
import { NoteDto } from '@models/note-dto.interface';

@Injectable({
  providedIn: 'root'
})
export class ProjectNotesProvider implements NotesProvider {
  private readonly apiService = inject(ApiService);

  getNotes(projectId: number): Observable<NoteDto[]> {
    return this.apiService.get(`projects/${projectId}/notes`);
  }

  addNote(projectId: number, text: string): Observable<unknown> {
    return this.apiService.post(`projects/${projectId}/notes`, { text });
  }

  updateNote(projectId: number, noteId: number, text: string): Observable<unknown> {
    return this.apiService.put(`projects/${projectId}/notes/${noteId}`, { text });
  }

  deleteNote(projectId: number, noteId: number): Observable<unknown> {
    return this.apiService.delete(`projects/${projectId}/notes/${noteId}`);
  }
}
